import { color, rem, radius } from '@thiememeulenhoff/lit-sdk';
import { indicatorSizeMap } from '@thiememeulenhoff/types';
import { css } from 'lit';

export const indicatorStyles = css`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }

  :host {
    align-items: center;
    border-radius: ${radius('extra-large')};
    color: ${color('grey', 800)};
    display: flex;
    justify-content: center;
  }

  :host([size='small']) {
    block-size: ${rem(indicatorSizeMap.small)};
    flex-basis: ${rem(indicatorSizeMap.small)};
    font-size: ${rem(indicatorSizeMap.small - 6)};
    inline-size: ${rem(indicatorSizeMap.small)};
  }

  :host([size='medium']) {
    block-size: ${rem(indicatorSizeMap.medium)};
    flex-basis: ${rem(indicatorSizeMap.medium)};
    font-size: ${rem(indicatorSizeMap.medium - 10)};
    inline-size: ${rem(indicatorSizeMap.medium)};
  }

  :host([type='todo']),
  :host([type='empty']) {
    background-color: ${color('grey', 200)};
    color: ${color('grey', 800)};
  }

  :host([type='done']) {
    background-color: ${color('blue', 300)};
    color: ${color('blue', 800)};
  }

  :host([type='correct']) {
    background-color: ${color('green', 600)};
    color: ${color('white')};
  }

  :host([type='incorrect']) {
    background-color: ${color('purple', 600)};
    color: ${color('white')};
  }

  :host([type='loading']) {
    animation: spin 2s linear infinite;
    background-color: ${color('grey', 200)};
    color: ${color('grey', 500)};
  }

  :host([type='predefined']) {
    color: ${color('green')};
  }
`;
